<template>
  <div id="BCDOverview">
    <BCDList :bcds="bcds" :bcd2subnets="bcd2subnets" :bcd2vlans="bcd2vlans" :ous="ous" :bcd2ous="bcd2ous"
      :default_sort_by="'name'" :bcd2vnis="bcd2vnis" :netcmpnds_by_name="netcmpnds_by_name" :netcmpnds_by_net_instnc="netcmpnds_by_net_instnc"
             :subnet2subnet_statistic="subnet2subnet_statistic"
    ></BCDList>
  </div>
</template>

<script>
import RangeService from '@/api-services/dns_bcd.service'
import BCDList from '@/components/BCDList'
import apiutil from '@/util/apiutil'

export default {
  name: 'BCDOverview',
  components: {BCDList},
  data() {
    return {
      bcds: null,
      bcd2vlans: null,
      bcd2subnets: null,
      subnet2subnet_statistic: null,
      ous: null,
      bcd2ous: null,
      bcd2vnis: null,
      netcmpnds_by_net_instnc: {},
      netcmpnds_by_name: {},
    }
  },
  async created() {
    const response = await RangeService.getOverview(this.$store.state)
    this.ous = response.data.unit_list
    this.bcds = response.data.bcd_list
    this.bcd2ous = response.data.bcd2ou_list
    this.bcd2subnets = apiutil.dict_of_lists_by_value_of_array(response.data.ip_subnet_list, 'bcd')
    this.subnet2subnet_statistic = apiutil.dict_by_value_of_array(response.data.ip_subnet_statistic_list, 'ip_subnet_gfk')
    this.bcd2vlans = apiutil.dict_of_lists_by_value_of_array(response.data.vlan_list, 'bcd')
    this.bcd2vnis = apiutil.dict_by_value_of_array(response.data.vxlan_list, 'bcd')
    this.netcmpnds_by_net_instnc = apiutil.dict_of_lists_by_value_of_array(response.data.net_cmpnd2instnc_list, 'net_instnc')
    this.netcmpnds_by_name = apiutil.dict_by_value_of_array(response.data.net_cmpnd_list, 'name')
  }
}
</script>

<style scoped>

</style>
